import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { derAutoCreateVirbom_terkk_ramfilteranauklizavanje_children, derAutoCreateVirbom_terkk_ramfilteranauklizavanje_prepare_vir_input, derivatPoluproizvod_ramfilteranauklizavanje_naziv } from "./ter-derivat-lib-terkk-ramfilteranauklizavanje";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { protobomp_manipulator } from "../utils/frfr-protobomp-utils";
import { terProtobompUtils_make_protobomp_manifest_terkk_latest } from "./ter-protobomp-utils";


// TER DRAFTEL CODECS LIB

/*
_bundle_ramfilteranauklizavanje u izradi

- 

TODO:
- 




*/


export const draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_ramfilteranauklizavanje',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR

    // _protobomp: protobomp_manipulator.init("klizac"),
    _protobomp: protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$ramfuk"), null),

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default
    /*

    */

    ramfuk_sirinab: 0,
    ramfuk_visinah: 0,
    ramfuk_a: 0,
    ramfuk_c: 0,

    kolicina: 1,

    // materijali
    // tipmetalalima // TODO
    ramfuk_materijal_lim: null,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.default_pods_input_state = () => {
  /*
  return {

  };
  */
  return default_pods_input_state_smart_get('terkk$ramfilteranauklizavanje');
};


draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.default_subform_item_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_ramfilteranauklizavanje_subform_item',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default


    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 

  ...Object.keys(draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.default_subform_item_preset_state())
];


draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.virtel_to_subDraftel = (virtel) => {
  // pretvara iz virtela u formState format
  //
  let state = {
    ...draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.default_subform_item_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.keys_for_direct_cloning)
  };
  //
  return state;
};


draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.subDrafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima

};


draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.bundleDrafel_to_paired_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$ramfilteranauklizavanje');
  console.log(formState);
  let state = {
    ...formState
  };
  const p = state;
  const ramfilteranauklizavanjeNaziv = '? Ram filtera na uklizavanje ?';
  p.naziv = ramfilteranauklizavanjeNaziv;
  //
  const _params = {
    "operacija": "OPSKL",
    "rc": "RCDE",
    // tergrupa: 'ramfilteranauklizavanje',
  };
  const virtel = {
    ...p,
    virtelschemakey: 'terkk$ramfilteranauklizavanje',
    paired_with_smartel: true,
    ..._get_fixed_fields(sema),
    ..._params,
    ..._getParamsFromLib("terkk$ramfilteranauklizavanje") // parametri na kraju imaju prioritet
  };
  return virtel; // return virtel
};


/////////


draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.bundleDraftel_to_unbundled_subDraftel_arr = (bundleDraftel) => {
  // draftel single BUNDLE to draftel array
  const bundle = bundleDraftel;
  let _unbundled_subDraftel_arr = [];
  const zajednicki_higher_props_za_items = {
    // meta
    parent_subkey: bundle.parent_subkey,
    superkey: bundle.superkey,
    // bundle_id: p.bundle_id,
    // od poluproizvoda

    // pods_input TODO Da li treba bolje resenje?
    flag_custom_pods_input: bundle.flag_custom_pods_input,
  };
  if (Array.isArray(bundle._subform_arr)) {
    bundle._subform_arr.forEach(_sf_item_raw => {
      let subDraftel_ramfilteranauklizavanje = {
        ...draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.default_preset_state(),
        ..._sf_item_raw,
        ...zajednicki_higher_props_za_items
      };
      _unbundled_subDraftel_arr.push(subDraftel_ramfilteranauklizavanje);
    });
  };
  return _unbundled_subDraftel_arr;
};


draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.bundleDrafel_to_virbom = (bundleDraftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$ramfilteranauklizavanje');

  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);

  const paired_virtel = draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.bundleDrafel_to_paired_virtel(bundleDraftel);

  const local_graphlevel = 1;
  _virbom_manipulator.add_as_first_virtel(virbom_ref, paired_virtel);

  // KORAK DODAVANJE CHILDRENA OD paired_virtel-a

  const _unbundled_subDraftel_arr = draftel_codecs_pack_terkk$_bundle_ramfilteranauklizavanje.bundleDraftel_to_unbundled_subDraftel_arr(bundleDraftel);

  let pods_input_za_derivate = derAutoCreateVirbom_terkk_ramfilteranauklizavanje_prepare_vir_input(paired_virtel); // ??? 
  let _der_virtel_children = derAutoCreateVirbom_terkk_ramfilteranauklizavanje_children(pods_input_za_derivate, _unbundled_subDraftel_arr);
  console.log('_der_virtel_children ramfilteranauklizavanje', _der_virtel_children);
  // USISAVANJE
  _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _der_virtel_children, local_graphlevel + 1, virbomCounter.generateFreshSubkey);

  // ZAVRSENI KORACI ZA JEDAN pp3
  // ***ZAVRSENI KORACI ZA JEDAN pp3

  // ZAVRSENI KORACI ZA JEDAN pp3

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};

